import {GET_FREEBET} from 'sagas/actions';

import * as CouponRateActions from 'actions/CouponRate';
import * as FreebetActions from 'actions/Freebet';
import * as HistoryBetActions from 'actions/HistoryBet';
import * as Freebet from 'actions/Freebet';

import * as BetTypes from 'constants/BetType';

export default function isFreebetReducer(isFreebet, freebet, betSlips, betTypes, currentBetTypeIndex, action) {
    switch (action.type) {
        case FreebetActions.TOGGLE_FREEBET:
            return isFreebet.update('isFreebet', () => action.data);

        case CouponRateActions.REMOVE_COUPON_RATES:
            isFreebet = isFreebet.update('freebetAvailable', () => false);
            return isFreebet.update('isFreebet', () => false);

        case CouponRateActions.SET_COUPON_BET_TYPE:
        case CouponRateActions.REMOVE_COUPON_RATE:
        case CouponRateActions.ADD_COUPON_RATE:
        case HistoryBetActions.SUCCESS_REQUEST_BET_TYPES:
        case GET_FREEBET.SUCCESS:
        case Freebet.SUCCESS_GET_FREEBET:
            return calculateIsFreebetAvailable(isFreebet, freebet, betSlips, betTypes, currentBetTypeIndex);
    }

    return isFreebet;
}

function calculateIsFreebetAvailable(isFreebet, freebet, betSlips, betTypes, currentBetTypeIndex) {
    if (!freebet || freebet.size === 0) {
        isFreebet = isFreebet.set('freebetAvailable', false);
        isFreebet = isFreebet.set('isFreebet', false);

        return isFreebet;
    }

    const maxFactorValue = freebet.get('maxFactorValue');

    const currentBetType = betTypes.get(currentBetTypeIndex);
    const odd = currentBetType ? currentBetType.odd : 0;

    const freebetAvailable = freebet && currentBetType &&
        (!maxFactorValue || maxFactorValue >= odd) &&
        ((betSlips.size === 1 && currentBetType.type === BetTypes.SINGLE) ||
        (betSlips.size > 1 && currentBetType.type !== BetTypes.SINGLE &&
        currentBetType.type !== BetTypes.SYSTEM));

    isFreebet = isFreebet.set('freebetAvailable', freebetAvailable);
    if (!freebetAvailable) {
        isFreebet = isFreebet.set('isFreebet', false);
    }

    return isFreebet;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/coupon/isFreebetReducer.js